import { render, staticRenderFns } from "./BigQueryPopup.vue?vue&type=template&id=8c596ec6"
import script from "./BigQueryPopup.vue?vue&type=script&lang=js"
export * from "./BigQueryPopup.vue?vue&type=script&lang=js"
import style0 from "./BigQueryPopup.vue?vue&type=style&index=0&id=8c596ec6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports